import React from 'react';

import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

import App from './App';
import ErrorBoundaryProvider from './contents/ErrorBoundaryProvider';
import LanguageProvider from './contents/intl/LanguageProvider';
import {initAppConfig} from './services/configService';
import {unregister} from './serviceWorker';
import {buildLogger} from './stores/businesses/logBusiness';
import configureStore from './stores/configureStore';
// import globalReduxStore from './stores/globalReduxStore';

import './index.scss';

const rootEl = document.getElementById('root');

const init = async () => {
  const {browserLogLevel, logLevel, logMaxStackSize, logKey, logger} = await initAppConfig();
  const store = configureStore(logger);

  // Enable access redux store outside components or action creators.
  // globalReduxStore.setStore(store);

  buildLogger(store, browserLogLevel, logLevel, logMaxStackSize, logKey);

  ReactDOM.render(
    <Provider store={store}>
      <LanguageProvider>
        <ErrorBoundaryProvider>
          <App />
        </ErrorBoundaryProvider>
      </LanguageProvider>
    </Provider>,
    rootEl,
  );
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();
init();
